<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.country.dialog.title' | translate"
		id="country-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="country-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.country.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1 align--medium-top">
						<ins-checkbox
							id="country-dialog-eu-member"
							[(ngModel)]="viewModel.bo.model.euMember"
							[label]="'scenes.configuration.shared.country.dialog.form.eu-member.label' | translate"
							[sklValidate]="getValidationKey('euMember')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.country.dialog.form.code.label' | translate">
							<ins-input
								id="country-dialog-code"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.code"
								[placeholder]="'scenes.configuration.shared.country.dialog.form.code.placeholder' | translate"
								[sklValidate]="getValidationKey('code')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.country.dialog.form.name.label' | translate">
							<ins-input
								id="country-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.country.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="country-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="country-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>